import React, { createContext, useCallback, useEffect, useState } from "react";
import { GetItinerary, getCatlog, getCollection } from "../../servies/services";
import { objectToQueryString } from "../../Library/Utility/Utility";
type defaultType = { id: string; name: string };
type ThemeContextType = {
    mainCategory: any;
    catlogData: any;
    updateCatlogData: (data: any) => void;
    productList: any;

};
export const ThemeContext = createContext<ThemeContextType>({
    mainCategory: [],
    catlogData: [],
    updateCatlogData: (data: any) => null,
    productList: []
});

const { Provider } = ThemeContext;

export const ThemeConsumer = ThemeContext.Consumer;

const defaultValue: defaultType = { id: "", name: "" };

type ThemeProviderProps = {
    children: any;
};

const ThemeProvider = ({ children }: ThemeProviderProps): any => {
    const [catlogData, setCatlogData] = useState<any>([]);

    const updateCatlogData = useCallback((data:any) => {
        setCatlogData(data);
    }, []);

    const [mainCategory, setMainCategory] = useState([]);
    useEffect(() => {
        const getData = async () => {
            const query = {
                status: "1"
            }
            const APIResponse = await GetItinerary(objectToQueryString(query));
            if (APIResponse?.data?.isSuccess === true) {
                let updatedList: any = []
                APIResponse?.data?.data?.map((item: any) => {
                    return updatedList.push({ text: item?.title, id: item?._id, value: item?.slug })
                })
                setMainCategory(APIResponse?.data?.data);
            } else {
                console.error("something went wrong, please try after sometime.")
            }
        };
        getData();
    }, [])

    // useEffect(() => {
    //     const getData = async () => {
    //         const query = {
    //             status: "1"
    //         }
    //         const APIResponse = await getCatlog(objectToQueryString(query));
    //         if (APIResponse?.data?.isSuccess === true) {
    //             if (APIResponse?.data?.data) {
    //                 updateCatlogData(APIResponse?.data?.data)
    //             }
    //         } else {
    //             console.error("something went wrong, please try after sometime.")
    //         }

    //     };
    //     getData();
    // }, [updateCatlogData])

    // console.log("customPostType", setMainCategory)

    const [productList, setProductList] = useState([]);
    // useEffect(() => {
    //     const getData = async () => {
    //         const query = {
    //             status: '1'
    //         }
    //         const APIResponse = await getCollection(objectToQueryString(query));
    //         if (APIResponse?.data?.isSuccess === true) {
    //             setProductList(APIResponse?.data?.data);
    //         } else {
    //             console.error("something went wrong, please try after sometime.")
    //         }
    //     };
    //     getData();
    // }, [])

    return (
        <>
            <Provider
                value={{
                    mainCategory,
                    catlogData,
                    updateCatlogData,
                    productList
                }}
            >
                {children}
            </Provider>
        </>
    );
};

export { ThemeProvider };
